import { TextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from '#src/pages/manage/security-breach/SecurityBreach.tsx';

import { nonEmptyString } from '../validation.ts';

export const UsersImpacted = () => {
  const { setValue } = useFormContext<FormValues>();
  return (
    <Controller
      name="usersImpacted"
      rules={{
        validate: nonEmptyString('Provide the number of users impacted'),
      }}
      render={({ field, fieldState }) => (
        <TextField
          required
          characterLimit={255}
          id="security-breach-number-impacted"
          onChange={field.onChange}
          label="How many hirers or candidates have been affected?"
          value={field.value}
          onClear={() => setValue('usersImpacted', '')}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
        />
      )}
    />
  );
};
